import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'seperate'
})
export class SeperatePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return value.replace(/\s+/g, '').replace(/^(.{3})(.{3})(.*)$/, "$1 $2 $3");;
  }

}
